module.exports = __webpack_public_path__ + "img/HairBoom_Logo_white.96b7756e.png";